export default {
  noTransactions: 'No supported on-chain transactions found.',
  tokenSwap: 'Token swap',
  receivedToken: 'Received token',
  sentToken: 'Sent token',
  transactionHash: 'Transaction hash',
  unknownToken: 'Unknown token',
  loadMore: 'Load more records',
  loadingMore: 'Loading 30 more records…',
  pullUpToLoad: 'Pull up to load more records',
  noMoreRecords: 'No more records',
  confirmed: 'Confirmed',
  swapSent: 'Sent',
  swapReceived: 'Received',
  onChainRecords: 'On-chain records',
  connectMetaMaskDescription: 'Connect MetaMask to view supported token transactions here.',
  loggedInDescription: 'Log in or connect World App to view supported token transactions here.',
  loadingRecords: 'Loading on-chain activity…',
  selectTransactionWallet: 'Select transaction wallet',
  bubbleWallet: {
    title: 'Game activity',
    loginRequired: 'Sign in to view Bubble Game spending and Bubble Wallet operations.',
    loading: 'Loading Bubble Wallet activity…',
    loadMore: 'Load more',
    loadingMore: 'Loading more…',
    noRecords: 'No Bubble Game spending or Bubble Wallet operations found.',
    recorded: 'Recorded',
    types: {
      shop_purchase_bbg: 'BBG equipment purchase',
      gacha_bbg: 'BBG character draw',
      furnace_bbt: 'BBT furnace',
      skin_purchase: 'Skin purchase',
      character_synthesis_bbg: 'BBG character synthesis',
      throne_challenge_bbg: 'BBG throne challenge',
      claim_bbg: 'Claim BBG',
      swap: 'Token swap',
      send: 'Send tokens',
    },
    statuses: {
      completed: 'Completed',
      failed: 'Failed',
      pending: 'Pending',
      unknown: 'Recorded',
    },
  },
} as const;
